import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { MesesEnum } from '../../../shared/dominios/enum/meses.enum';
import { ConsultaExtratoPreviModel } from '../../../shared/models/consulta-extrato-previ.model';
import { OcorRemidoWebModel } from '../../../shared/models/orco-remido-web.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { RemidoWebModel } from '../../../shared/models/remido-web.model';
import { FPCConsultaFracaoPatrimonialPdf } from '../../../shared/services/documentos-pdf-imprimir/Plano/fpc/fpc-consulta-fracao-patrimonial-pdf';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { FpcService } from '../service/fpc.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';

@Component({
  selector: 'app-fpc-consulta-fracao-patrimonial',
  templateUrl: './fpc-consulta-fracao-patrimonial.component.html',
  styleUrls: ['./fpc-consulta-fracao-patrimonial.component.css']
})
export class FpcConsultaFracaoPatrimonialComponent implements OnInit {

  componentes: any[] = [1];

  @BlockUI() blockUi: NgBlockUI;

  ocorRemidoWebModel: Array<OcorRemidoWebModel> = new Array<OcorRemidoWebModel>();

  consultaExtratoPreviModel: Array<ConsultaExtratoPreviModel> = new Array<ConsultaExtratoPreviModel>();

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();
  remidoWebModel: RemidoWebModel = new RemidoWebModel();

  // 23329	7462800	NEWTON LUIZ DE ATAIDE TRINDADE

  cdCentrus: number;
  cdCentrusTit: number;


  param: string;
  titulo: string;

  page = 0;
  rows = 14;
  totalRecords = 0;

  irImposto96 = 0;
  irImposto97 = 0;
  irImposto98 = 0;
  irImposto99 = 0;
  irIof99 = 0;
  liberarDemonstrativoPrevi = false;
  dsPagamento: string;
  liberarDemonstrativoPreviTanela = false;

  constructor(
    private fpcService: FpcService,
    private pessoaService: PessoaService,
    private router: Router,
    private authInterceptor: AuthInterceptor,
    private toastrService: ToastrService,
    private fPCConsultaFracaoPatrimonialPdf: FPCConsultaFracaoPatrimonialPdf
  ) { }

  ngOnInit() {

    this._gerenciarCodigoIndentificao();

  }

  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param = '/cardMenus/cardMenuPlanos';
        }
        this.getPessoasDadosSimplificado();
      })
  }




  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getPageConsultaOcorrenciasRemido();
      this.getConsultaRemido();
      this.getConsultaExtratoPrevi();
      this.getBuscarDestinoPagto();
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }


  paginacao(evento) {
    this.page = evento['page'];
    this.rows = evento['rows'];
    this.getPageConsultaOcorrenciasRemido();
  }

  async getPageConsultaOcorrenciasRemido() {

    this.blockUi.start('Carregando...');
    try {

      const ocorRemidoWebList = await this.fpcService.getPageConsultaOcorrenciasRemido(this.cdCentrus, this.rows, this.page);
      const cdSitFunc = Number(await this.fpcService.getObterSituacaoFuncBacen(this.cdCentrus));

      this.totalRecords = ocorRemidoWebList['totalElements'];

      this._identificaoImpostoTipo(ocorRemidoWebList);
      this.ocorRemidoWebModel = this._configurarInformacoesLista(ocorRemidoWebList['content'], cdSitFunc);

    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    } finally {
      this.blockUi.stop();
    }
  }


  private _identificaoImpostoTipo(ocorRemidoWebList: Array<OcorRemidoWebModel>) {
    for (const item of ocorRemidoWebList) {
      if (item.tpOcorrencia === 79) {
        this.irImposto96 = 79;
      } else if (item.tpOcorrencia === 81) {
        this.irImposto97 = 81;
      } else if (item.tpOcorrencia === 82) {
        this.irImposto98 = 82;
      } else if (item.tpOcorrencia === 83) {
        this.irImposto99 = 83;
      } else if (item.tpOcorrencia === 84) {
        this.irIof99 = 84;

      } else if (item.tpOcorrencia === 314) {
        if (this.irImposto96 === 0) {
          this.irImposto96 = 314;
        }
      } else if (item.tpOcorrencia === 315) {
        if ((this.irImposto97 === 0) &&
          (Number(item.vlocorrencia) >= 1)) {  // valor > 0
          this.irImposto97 = 315;
        }
      } else if (item.tpOcorrencia === 316) {
        if ((this.irImposto98 === 0) &&
          (Number(item.vlocorrencia) >= 1)) {  // valor > 0
          this.irImposto98 = 316;
        }
      } else if (item.tpOcorrencia === 317) {
        if ((this.irImposto99 = 0) &&
          (Number(item.vlocorrencia) >= 1)) {   // valor > 0
          this.irImposto99 = 317;
        }
      } else if (item.tpOcorrencia === 318) {
        if ((this.irIof99 === 0) &&
          (Number(item.vlocorrencia) >= 1)) {   // valor > 0
          this.irIof99 = 318;
        }
      }

    }
  }


  private _configurarInformacoesLista(ocorRemidoWebList: Array<OcorRemidoWebModel>, cdSitFunc): Array<OcorRemidoWebModel> {

    const listaRetorno = new Array<OcorRemidoWebModel>();

    for (const item of ocorRemidoWebList) {
      const ocorRemidoWebRecepcao: OcorRemidoWebModel = new OcorRemidoWebModel();

      if ((cdSitFunc !== 273) &&
        (((Number(item.tpOcorrencia) === 314) &&
          (this.irImposto96 === 314)) ||
          ((Number(item.tpOcorrencia) === 315) &&
            (this.irImposto97 === 315)) ||
          ((Number(item.tpOcorrencia) === 316) &&
            (this.irImposto98 === 316)) ||
          ((Number(item.tpOcorrencia) === 317) &&
            (this.irImposto99 === 317)) ||
          ((Number(item.tpOcorrencia) === 318) &&
            (this.irIof99 === 318)))) {
        ocorRemidoWebRecepcao.dtReferencia = this.formatData(item.dtReferencia);
        ocorRemidoWebRecepcao.dsocorrencia = item.dsocorrencia;
        ocorRemidoWebRecepcao.vlocorrencia = item.vlocorrencia;
        ocorRemidoWebRecepcao.vlSaldo = item.vlSaldo;
      } else if (Number(item.tpOcorrencia) === 300) {
        this.liberarDemonstrativoPreviTanela = true;
        ocorRemidoWebRecepcao.tpOcorrencia = 300;
        ocorRemidoWebRecepcao.dtReferencia = this.formatData(item.dtReferencia);
        ocorRemidoWebRecepcao.dsocorrencia = item.dsocorrencia;
        ocorRemidoWebRecepcao.vlocorrencia = item.vlocorrencia;
        ocorRemidoWebRecepcao.vlSaldo = item.vlSaldo;
      } else {
        ocorRemidoWebRecepcao.dtReferencia = this.formatData(item.dtReferencia);
        ocorRemidoWebRecepcao.dsocorrencia = item.dsocorrencia;
        ocorRemidoWebRecepcao.vlocorrencia = item.vlocorrencia;
        ocorRemidoWebRecepcao.vlSaldo = item.vlSaldo;
      }

      listaRetorno.push(ocorRemidoWebRecepcao);

    }


    return listaRetorno;
  }


  private formatData(dtReferencia: string): string {
    const mes = Number(dtReferencia.substr(0, 2))
    const ano = Number(dtReferencia.split('/')[1])
    return `${MesesEnum.getDescricao(mes)}/${ano}`
  }

  async getConsultaRemido() {
    try {
      this.remidoWebModel = await this.fpcService.getConsultaRemido(this.cdCentrus);
      (this.remidoWebModel.irFiliacao === '1') ? this.remidoWebModel.irFiliacao = 'SIM' : this.remidoWebModel.irFiliacao = 'NÃO';
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }

  async getConsultaExtratoPrevi() {
    try {
      this.consultaExtratoPreviModel = await this.fpcService.getConsultaExtratoPrevi(this.cdCentrus);

      if (!this.consultaExtratoPreviModel) { this.liberarDemonstrativoPrevi = true };
    } catch (error) {
      console.error(error);
    }
  }


  async getBuscarDestinoPagto() {

    try {
      const buscarDestinoPagto = Number(await this.fpcService.getBuscarDestinoPagto(this.cdCentrus));


      if (buscarDestinoPagto === 1) {
        this.dsPagamento = (`Destino do Pagamento:              Cheque no caixa`);
      } else if (buscarDestinoPagto === 3) {
        this.dsPagamento = (`Destino do Pagamento:              DOC p/Poupança`);
      } else if (buscarDestinoPagto === 5) {
        this.dsPagamento = (`Destino do Pagamento:              Crédito em Conta`);
      } else if (buscarDestinoPagto === 7) {
        this.dsPagamento = (`Destino do Pagamento:              Pensão`);
      } else if (buscarDestinoPagto === 9) {
        this.dsPagamento = (`Destino do Pagamento:              DOC`);
      } else { this.dsPagamento = ` ` };

    } catch (error) {
      console.error(error);
    }
  }


  direcionar() {
    this.router.navigate(['planos/plano/fpcExtrato'], { skipLocationChange: false });
  }



  async imprimirPagina() {
    try {

      const ocorRemidoWebList = Object.values(await this.fpcService.getConsultaOcorrenciasRemido(this.cdCentrus));
      const cdSitFunc = Number(await this.fpcService.getObterSituacaoFuncBacen(this.cdCentrus));

      this._identificaoImpostoTipo(ocorRemidoWebList);
      const ocorRemidoWebPdf = this._configurarInformacoesLista(ocorRemidoWebList, cdSitFunc);

      this.fPCConsultaFracaoPatrimonialPdf.funcionarios(
        this.dsPagamento,
        this.pessoaDadosSimplicadosModel,
        this.remidoWebModel,
        ocorRemidoWebPdf);
    } catch (error) {
      console.error(error);
    }
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/fpc/fpc-consulta-fracao-patrimonial/fpc-consulta-fracao-patrimonial.component.ts